import { useEffect } from "react";
import {
  useDispatch,
  useSelector,
} from "react-redux";
import { setPosts } from "../../state";
import * as Config  from "../../config";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
import PostWidget from "./PostWidget";


const PostsWidget = ({
    userId,
    isProfile = false,
  }) => {
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.posts);
  const token = useSelector((state) => state.token);

  const getPosts = async () => {
    const response = await fetch(`${Config.expressUri}/posts`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    dispatch(setPosts({ posts: data }));
  };

  const getUserPosts = async () => {
    const response = await fetch(
      `${Config.expressUri}/posts/${userId}/posts`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const data = await response.json();
    dispatch(setPosts({ posts: data }));
  };

  useEffect(() => {
    if (isProfile) {
      getUserPosts();
    } else {
      getPosts();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {posts.map(
        ({
          _id,
          userId,
          firstName,
          lastName,
          description,
          location,
          picturePath,
          userPicturePath,
          likes,
          comments,
        }) => (
          <PostWidget
            key={_id}
            postId={_id}
            postUserId={userId}
            name={`${firstName} ${lastName}`}
            description={description}
            location={location}
            picturePath={picturePath}
            userPicturePath={userPicturePath}
            likes={likes}
            comments={comments}
          />
        )
      )}
    </>
  );
};

export default PostsWidget;


// NEVER DID THIS. NEVER WORKED OUT:
// Above I changed posts.map to posts.reverse.map to get newest first (crudely speaking).
// It should be a shallow copy. Anyhow, it really needs to be done by the DB or at least the model.
// Or does it? Is it correct to offload processing to the browser? There are so many ways to slice and dice
// the solution for high efficiency but browsers can do a lot before getting overloaded nowadays.

